/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { AccordionHeader, AccordionItem, theme } from "@nordcloud/gnui";
import { DiscoveryRule } from "~/models";

type Props = {
  rule: DiscoveryRule;
  idx: number;
};

const Tag = styled.span`
  color: ${theme.color.text.text02};
`;

function formatArray(data: string[]): string {
  return (data || []).join(", ");
}

function listEntry(label: string, data?: string) {
  return data ? (
    <li>
      <Tag>{label}:</Tag> {data}
    </li>
  ) : null;
}

function DiscoveryRuleDisplay({ rule, idx }: Props) {
  const tags = (rule.match.tags || [])
    .map((tag) => `${tag.key} = ${tag.value}`)
    .join(", ");

  const resourceTypes = (rule.match.type || [])
    .map((type, i) => `${type}/${rule.match.subtype[i]}`)
    .join(", ");

  const resourceGroups = formatArray(rule.match.resourceGroup);
  const cloudAccounts = formatArray(rule.match.cloudAccount);
  const subnets = formatArray(rule.match.subnetIds);
  const securityGroups = formatArray(rule.match.securityGroupIds);
  const projectIds = formatArray(rule.match.projectId);

  return (
    <AccordionHeader title={`Rule #${idx}`}>
      <AccordionItem>
        <ul css={{ listStyle: "inside" }}>
          {listEntry("Tags", tags)}
          {listEntry("Resource groups", resourceGroups)}
          {listEntry("Resource types", resourceTypes)}
          {listEntry("Cloud accounts", cloudAccounts)}
          {listEntry("AWS subnets", subnets)}
          {listEntry("AWS security groups", securityGroups)}
          {listEntry("Google Cloud projects", projectIds)}
        </ul>
      </AccordionItem>
    </AccordionHeader>
  );
}

export { DiscoveryRuleDisplay };
